/**
 * YouTube / Vimeo URL parsing helpers, used by the shared TinyMCE `media_url_resolver`.
 */

const YOUTUBE_ID_RE = /^[A-Za-z0-9_-]{11}$/;

const toUrl = (rawUrl) => {
  try {
    return new URL(/^https?:\/\//i.test(rawUrl) ? rawUrl : `https://${rawUrl}`);
  } catch {
    return null;
  }
};

/**
 * Supports youtube.com/watch?v=, youtu.be/, and youtube.com/embed/ links.
 * @returns {string | null} the 11-character video id, or null
 */
export const parseYoutubeVideoId = (rawUrl) => {
  const url = toUrl(rawUrl);
  if (!url) return null;

  const host = url.hostname.replace(/^www\./i, "").toLowerCase();

  if (host === "youtu.be") {
    const id = url.pathname.split("/").filter(Boolean)[0];
    return id && YOUTUBE_ID_RE.test(id) ? id : null;
  }

  if (host === "youtube.com" || host === "m.youtube.com") {
    if (url.pathname === "/watch") {
      const id = url.searchParams.get("v");
      return id && YOUTUBE_ID_RE.test(id) ? id : null;
    }

    const embedMatch = url.pathname.match(/^\/embed\/([A-Za-z0-9_-]{11})/);
    if (embedMatch) return embedMatch[1];
  }

  return null;
};

/**
 * Supports vimeo.com/{id} links.
 * @returns {string | null} the numeric video id, or null
 */
export const parseVimeoVideoId = (rawUrl) => {
  const url = toUrl(rawUrl);
  if (!url) return null;

  const host = url.hostname.replace(/^www\./i, "").toLowerCase();
  if (host !== "vimeo.com") return null;

  const match = url.pathname.match(/^\/(\d+)/);
  return match ? match[1] : null;
};
